import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getRefFromId,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import { useSnackbar } from "notistack";
import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import TextField2 from "../textfields/TextField2.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import sendATHSPE from "../api/send/sendATHSPE.js";
import { Token } from "@mui/icons-material";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { addActivityLog } from "../config/OnlineStatus.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { DisplayATHSPE } from "../pages/parameters/ATHSPE.js";

const GenerateATHSPE = ({
  document,
  folder,
  orgData,
  userData,
  onClose,
  onUpdate,
}) => {
  const [add_to_planning, setAddToPlanning] = useState(true);
  const [include_ath, setIncludeAth] = useState(true);
  const [include_photos, setIncludePhotos] = useState(true);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingData = false, setLoadingData] = useState(false);

  function addVariableToContent(content) {
    let variables = [
      {
        tag: "@nom",
        value: folder.nom || "",
      },
      {
        tag: "@adresse",
        value: folder.adresse || "",
      },
      {
        tag: "@ville",
        value: folder.ville || "",
      },
      {
        tag: "@postal",
        value: folder.postal || "",
      },
      {
        tag: "@date",
        value: moment().format("DD/MM/YYYY") || "",
      },
    ];
    let newContent = content;
    variables.forEach((variable) => {
      // find and replace all occurences of the variable

      newContent = newContent.replace(
        new RegExp(variable.tag, "g"),
        variable.value
      );
    });
    return newContent;
  }

  const [content, setContent] = useState(
    addVariableToContent(
      orgData.config?.athspe?.default_content ||
        "M/MME @nom,\nAtteste sur l’honneur qu’une collerette de conduit de poêle étanche à l’air sera installé, dans la maison de @nom située @adresse @ville @postal, pour être en accord avec la règlementation environnementale RE2020."
    )
  );
  const [footer, setFooter] = useState(
    orgData.name +
      " " +
      orgData.infos?.phone +
      " " +
      orgData.infos?.email +
      " " +
      orgData.infos?.adresse +
      " " +
      orgData.infos?.postal +
      " " +
      orgData.infos?.ville
  );
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleGenerateATHSPE = async () => {
    if (!content) {
      handleClickVariant(
        "Veuillez renseigner le contenu de l'attestation",
        "error"
      );
      return;
    }
    setLoadingData(true);
    const logo =
      orgData.config?.ath?.hide_my_logo === true
        ? "https://i.ibb.co/6NW6dkp/Hexagone-UXLogo3-LOW-1024.png"
        : orgData.logo ||
          "https://i.ibb.co/CWHxrfX/Hexagone-UXLogo3-LOW-1024.png";
    let dict = {
      logo_url: logo,
      head: {
        number: dayjs().format("YYYYMMDDHHmmss"),
        date: dayjs().format("DD/MM/YYYY"),
      },
      body: {
        content: content,
      },
      sign: {
        city: folder.ville,
        date: dayjs().format("DD/MM/YYYY"),
      },
      footer: footer,
      document_id: document.id,
    };
    const token = await getOrRefreshFirebaseToken();
    let res = await sendATHSPE(folder.id, dict, token, prefix);
    if (!res) {
      handleClickVariant("Erreur lors de la génération de l'ATH SPE", "error");
      setLoadingData(false);
      return;
    }

    // check f type is list
    await updateDocDataFieldApi(document.ref, "champs", res, prefix);
    await updateDocDataFieldApi(document.ref, "state", "open", prefix);
    await addActivityLog(
      "ATH SPE générée",
      folder.ref,
      orgData.id,
      userData.id,
      "attestation_generated",
      prefix
    );

    handleClickVariant(
      "L'ATH SPE a été générée et envoyée à la signature",
      "success"
    );
    await onUpdate();
    onClose();
    setLoadingData(false);
  };

  return (
    <div className="flex flex-col bg-white rounded-3xl p-6 w-fit h-full max-h-[80vh] overflow-y-auto">
      <div className=" text-h2 flex flex-row justify-between w-full">
        Génération de l'attestaion spéciale
        <SecondaryButton className="w-fit" onClick={onClose}>
          Fermer
        </SecondaryButton>
      </div>
      <DisplayATHSPE
        orgData={orgData}
        content={content}
        setContent={setContent}
        footer={footer}
        setFooter={setFooter}
      ></DisplayATHSPE>
      <div className="flex flex-row gap-2 justify-end mt-4">
        <PrimaryButton
          onClick={handleGenerateATHSPE}
          disabled={loadingData}
          className={"w-fit"}
        >
          Générer et demander la signature
          <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default GenerateATHSPE;
